module.exports = __webpack_public_path__ + "public/Icons/adminmobileDark.svg?e67058e5";